import Number from "./Number";
import Time from "./Time";

const Quantity = Object.assign(Number, {
  Time,
});

export default Quantity;
